<template>
  <el-dialog
    class="sz-dialog"
    custom-class="sz-dialog"
    :modal="false"
    modal-append-to-body
    :visible.sync="modal"
  >
    <template #title></template>
    <div class="sz-modal" v-if="show">
      <transition name="fade"><div class="sz-modal-shadow"></div></transition>
      <div
        class="sz-modal-content"
        :style="style"
        :class="{ active: showContent }"
      >
        <div class="sz-modal-wrapper">
          <div class="sz-modal-header">
            <div class="header-title">
              <div>{{ title }}</div>
              <el-radio-group v-if="showRadio" class="header-radio" v-model="typeRadio" size="small" @change="changeType">
                <el-radio-button label="生产工艺"></el-radio-button>
                <el-radio-button label="视频监控"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="header-button">
              <img src="./images/close.svg" @click="onClose" alt="" />
            </div>
          </div>
          <div class="sz-modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog, Radio, RadioGroup, RadioButton } from "element-ui";
export default {
  name: "szModal",
  components: { ElDialog: Dialog, ElRadio: Radio, ElRadioGroup: RadioGroup, ElRadioButton: RadioButton },
  props: {
    title: {
      type: String,
      default: "视频监控",
    },
    height: {
      type: String,
      default: "660px",
    },
    width: {
      type: String,
      default: "1000px",
    },
    value: {
      type: Boolean,
      default: false,
    },
    showRadio: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      modal: false,
      show: false,
      showContent: this.value,
      style: {
        height: "0",
        width: "0",
      },
      typeRadio: "生产工艺"
    };
  },
  watch: {
    value(v) {
      if (v) {
        this.modal = v;
        setTimeout(() => {
          this.show = v;
          setTimeout(() => {
            this.showContent = true;
            this.style = {
              height: this.height,
              width: this.width,
            };
          }, 100);
        }, 100);
      } else {
        this.modal = false;
        this.show = false;
        this.showContent = false;
      }
    },
  },
  methods: {
    onClose() {
      this.showContent = false;
      this.style.height = "0px";
      this.style.width = "0px";
      this.typeRadio = "生产工艺"
      setTimeout(() => {
        this.show = this.showContent;

        this.$emit("input", false);
        setTimeout(() => {
          this.modal = false;
        }, 100);
      }, 1600);
    },
    changeType(e) {
      this.typeRadio = e;
      this.$emit("changeTypeRadio", e)
    }
  },
};
</script>

<style lang="less" scoped>
.sz-modal {
  z-index: 9001;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  &-shadow {
    background: rgba(1, 15, 22, 0.5);
    backdrop-filter: blur(2px);
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  &-header {
    height: 40px;
    background-repeat: no-repeat;
    background-image: url("./images/header-bg2.svg");
    display: flex;
    align-items: center;
    padding-left: 32px;
    position: relative;
    flex-shrink: 0;

    .header-title {
      //font-family: PingFangSC-Semibold, PingFang SC;
      color: #01d1ff;
      font-weight: 400;
      font-size: 18px;
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .header-radio {
      margin-right: 10px;
    }
    .header-button {
      img {
        cursor: pointer;
      }
    }
  }

  &-wrapper {
    height: 100%;
    flex: 1;
    width: 100%;
    padding: 25px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }

  &-body {
    flex: 1;
    position: relative;
    overflow: hidden;
  }

  &-content {
    position: relative;
    color: #fafbfa;
    background: rgba(10, 21, 32, 0.8);
    border: 1px solid #eeea10;
    box-shadow: 0 0 5px #d18600, 0 0 200px #ffee00;
    display: flex;
    z-index: 1002;
    flex-direction: column;
    overflow: hidden;
    width: 0;
    height: 0;
    padding: 0;
    transition: padding 0.3s, width 0.5s 1s, height 0.5s, border 0.3s,
      box-shadow 0.3s 0.3s;
    &.active {
      transition: height 0.5s 1s, width 0.8s, border 0.3s 1.3s,
        box-shadow 0.3s 1s, padding 0.3s 1.3s;
      border: 1px solid #052b40;
      box-shadow: none;
    }
  }
}
</style>
